import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { FullPageSpinner } from "../lib";
import { fetchMeldungHistorie, TransferHistory } from "../ElectronicIllnessAttestationHistory";
import { fetchMitarbeiterInfos } from "./fetchMitarbeiterInfos";

function ElectronicIllnessAttestationHistory(props) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const { accessToken, client } = props;

  const [isLoading, setIsLoading] = useState(true);
  const { showErrorMessage } = useMessage();

  const [meldungHistory, setMeldungHistory] = useState({
    allKeysByDate: [],
    byKey: {},
  });
  const [maInfos, setMaInfos] = useState({});

  const meldungFuerUserId = useMemo(() => {
    if (searchParams && searchParams.get("userId")) {
      return searchParams.get("userId");
    } else {
      return null;
    }
  }, [searchParams]);

  const program = useMemo(() => {
    if (location && location.pathname.startsWith("/SNDAUM")) {
      return "SNDAUM";
    } else {
      return "SENDAU";
    }
  }, [location]);

  const handleLoadMeldungHistory = () => {
    setMeldungHistory({
      allKeysByDate: [],
      byKey: {},
    });
    fetchMeldungHistorie(client, accessToken, program, meldungFuerUserId, true)
      .then((history) => {
        setMeldungHistory(history);
      })
      .catch((err) => {
        showErrorMessage(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    handleLoadMeldungHistory();

    setMaInfos({});
    if (meldungFuerUserId && program === "SNDAUM") {
      fetchMitarbeiterInfos(client, accessToken, program, meldungFuerUserId)
        .then((infos) => {
          setMaInfos(infos);
        })
        .catch((err) => {
          showErrorMessage(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [meldungFuerUserId, program]);

  const isVorgesetzenModus = useMemo(() => {
    return meldungFuerUserId && program === "SNDAUM" && maInfos && maInfos.pnr;
  }, [meldungFuerUserId, program, maInfos]);

  if (isLoading) {
    return <FullPageSpinner />;
  }
  return (
    <Page>
      <Layout>
        <Box p={1}>
          {isVorgesetzenModus && (
            <Grid px={1} item xs={12}>
              <Box p={1}>
                <Typography align="left">{t("Für wen?")}</Typography>
                <TextField value={`${maInfos.pnr} ${maInfos.vorname} ${maInfos.nachname}`} variant="outlined" fullWidth disabled={true} />
              </Box>
            </Grid>
          )}
          <TransferHistory history={meldungHistory} hideSearchbar={false} reloadHistory={handleLoadMeldungHistory} program={program} />
        </Box>
      </Layout>

      {isLoading && <FullPageSpinner />}
    </Page>
  );
}
export default ElectronicIllnessAttestationHistory;
